"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var formatAddress = function formatAddress(_ref) {
  var _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? "AT" : _ref$countryCode,
      countryTitle = _ref.countryTitle,
      stateTitle = _ref.stateTitle,
      street = _ref.street,
      town = _ref.town,
      zipCode = _ref.zipCode;
  var addressArr = [];
  var zipAndTown = [];
  var formattedCountryCode = countryCode.toUpperCase();
  if (zipCode) zipAndTown.push(zipCode);
  if (town) zipAndTown.push(town);
  if (street) addressArr.push(street);
  if (zipAndTown.length > 0) addressArr.push(zipAndTown.join(" "));
  if (stateTitle) addressArr.push(stateTitle);
  if (countryCode) addressArr.push("<img alt=\"".concat(countryTitle ? countryTitle : formattedCountryCode, "\" src=\"http://purecatamphetamine.github.io/country-flag-icons/3x2/").concat(formattedCountryCode, ".svg\" style=\"display: inline-block; margin-right: 8px; vertical-align: middle; width: 16px\"/>").concat(countryTitle ? countryTitle : formattedCountryCode));
  return addressArr.join("<br />");
};

var _default = formatAddress;
exports.default = _default;